import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  AppBar, 
  Toolbar, 
  IconButton, 
  Button, 
  Box, 
  Tooltip, 
  Avatar,
  Typography 
} from '@mui/material';
import { 
  Home, 
  LogOut, 
  ChevronLeft, 
  User 
} from 'lucide-react';

import SidebarMenu from './SidebarMenu.jsx'; 
import Notification from '../SignalR/Notificacion.jsx'; 

const PALETTE = {
  ice: "#C2EDF0",
  sky: "#99D9DF",
  pearl: "#EEF3F4",
  aqua: "#00C0CA",
  teal: "#008B9C",
  dark: "#22404D",
  red: "#F65F4E"
};

const NavBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [estaLogeado, setLogeado] = useState(false);
    const navigate = useNavigate();
    
    const userEmail = localStorage.getItem("email");

    const logout = () => {
        localStorage.clear();
        setLogeado(false);
        navigate("/");
        window.location.reload();
    };

    const handleHome = () => {
        const rol = localStorage.getItem("rol");
        if (rol === "coordinador") navigate("/dashboardCoordinador");
        else if (rol === "finanzas") navigate("/dashboardFinanzas");
        else navigate("/");
    };

    const handleVolver = () => navigate(-1);

    useEffect(() => {
        const updateLogStatus = () => {
            setLogeado(!!localStorage.getItem("email"));
        };   
        updateLogStatus();
        const intervalId = setInterval(updateLogStatus, 1000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        estaLogeado && (
            <>
                <AppBar 
                    position="fixed" 
                    sx={{ 
                        backgroundColor: 'rgba(255, 255, 255, 0.85)', 
                        backdropFilter: 'blur(16px)',
                        borderBottom: `1px solid rgba(0,0,0,0.05)`,
                        boxShadow: 'none',
                        zIndex: (theme) => theme.zIndex.drawer + 1
                    }}
                >
                    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Tooltip title="Ir al Inicio">
                                <IconButton 
                                    onClick={handleHome}
                                    sx={{ 
                                        color: PALETTE.dark, 
                                        backgroundColor: PALETTE.ice,
                                        borderRadius: '14px',
                                        "&:hover": { 
                                            backgroundColor: PALETTE.aqua,
                                            color: 'white'
                                        } 
                                    }}
                                >
                                    <Home size={22} />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Volver atrás">
                                <IconButton 
                                    onClick={handleVolver}
                                    sx={{ color: PALETTE.dark, ml: 1, "&:hover": { color: PALETTE.aqua } }}
                                >
                                    <ChevronLeft size={24} />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2.5 } }}>
                            <Box sx={{ 
                                "& .MuiIconButton-root": { color: PALETTE.aqua },
                                transition: '0.3s',
                                "&:hover": { transform: 'rotate(15deg)' }
                            }}>
                                <Notification />
                            </Box>

                            <Box sx={{ 
                                display: { xs: 'none', sm: 'flex' }, 
                                alignItems: 'center', 
                                gap: 1.5,
                                px: 1.5, py: 0.8,
                                borderRadius: '16px',
                                backgroundColor: '#F8FAFC',
                                border: '1px solid #E2E8F0'
                            }}>
                                <Avatar sx={{ width: 30, height: 30, bgcolor: PALETTE.dark, fontSize: '0.8rem', fontWeight: 800 }}>
                                    {userEmail?.charAt(0).toUpperCase()}
                                </Avatar>
                                <Typography variant="caption" sx={{ color: PALETTE.dark, fontWeight: 900 }}>
                                    {userEmail?.split('@')[0].toUpperCase()}
                                </Typography>
                            </Box>

                            <Button 
                                onClick={logout}
                                startIcon={<LogOut size={18} />}
                                sx={{ color: PALETTE.red, fontWeight: 900, textTransform: 'none' }}
                            >
                                Salir
                            </Button>
                        </Box>
                    </Toolbar>
                </AppBar>

                <SidebarMenu isOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(false)} />
                
                {/* Compensación de altura para el AppBar fixed (64px suele ser el alto del Toolbar) */}
                <Box sx={{ height: '64px' }} />
            </>
        )
    );
};

export default NavBar;